import { useState } from 'react';
import GeofenceDrawModal from '../../../../components/GeofenceDrawModal/GeofenceDrawModal';
import { getAiSpaceCount } from '../../listingDisplay';
import {
    buildGeofenceStaticMapUrl,
    computeAcres,
    countVertices,
} from '../../../../utils/geofenceUtils';
import { isBulkDraftListing } from '../drawerEditHelpers';

export default function GeofencePreview({
    listing,
    editMode = false,
    onGeofenceSaved,
    onGeofenceModalClose,
    onRequestEdit,
}) {
    const [modalOpen, setModalOpen] = useState(false);
    const geofence = listing.geofence;
    const mapUrl = buildGeofenceStaticMapUrl(geofence, 480, 200, {
        ingress: listing.ingress,
        egress: listing.egress,
    });
    const vertices = countVertices(geofence);
    const acres = computeAcres(geofence);
    const aiSpots = getAiSpaceCount(listing);
    const hasAddress = Boolean(
        listing.addressData?.formatted_address
        || listing.addressData?.formattedAddress,
    );
    const isBulkDraft = isBulkDraftListing(listing);
    const isEmpty = !mapUrl;

    const handleRequestEdit = () => {
        onRequestEdit?.();
        if (isBulkDraftListing(listing)) {
            setModalOpen(true);
        }
    };

    return (
        <div className="host-panel-section">
            <div className="host-panel-section-header">
                <div className="host-panel-section-label">Geofence</div>
                {!editMode && isEmpty && onRequestEdit && (
                    <button
                        type="button"
                        className="host-section-edit-link"
                        onClick={handleRequestEdit}
                    >
                        Edit →
                    </button>
                )}
            </div>
            {mapUrl ? (
                <>
                    <img
                        src={mapUrl}
                        alt="Parking boundary map"
                        className="drawer-geofence-map"
                    />
                    <div className="drawer-geofence-meta">
                        {vertices} vertices
                        {aiSpots != null ? ` · ~${aiSpots} estimated spots` : ''}
                        {acres != null ? ` · ${acres.toFixed(1)} acres` : ''}
                    </div>
                </>
            ) : isBulkDraft ? (
                <div className="required-missing-block">
                    <div className="host-summary-label">Parking boundary</div>
                    <div className="host-summary-value">No Parking Boundary Set</div>
                </div>
            ) : (
                <p className="drawer-empty-note">No parking boundary set yet</p>
            )}
            {editMode && (
                <button
                    type="button"
                    className="btn btn-secondary drawer-geofence-edit-btn"
                    onClick={() => setModalOpen(true)}
                >
                    Edit geofence
                </button>
            )}
            <GeofenceDrawModal
                open={modalOpen}
                onClose={() => {
                    setModalOpen(false);
                    onGeofenceModalClose?.();
                }}
                listingId={listing._id}
                initialGeofence={listing.geofence}
                initialIngress={listing.ingress || []}
                initialEgress={listing.egress || []}
                initialEnrichmentFields={listing.enrichmentFields}
                addressData={listing.addressData}
                hasAddress={hasAddress}
                onSaved={(payload) => {
                    onGeofenceSaved?.(payload);
                }}
            />
        </div>
    );
}
